export type MenuLink = {
  name: string
  link: string
}

const data: MenuLink[] = [
  {
    name: `About`,
    link: `about`,
  },
  {
    name: `Career`,
    link: `career`,
  },
  {
    name: `Projects`,
    link: `projects`,
  },
  {
    name: `Contact`,
    link: `contact`,
  },
]

export default data
